import { create } from 'zustand';

import { ApiDashboardResponseV2 } from '@/shared/api/generated/data-contracts';

export type AnalyticsState = {
  data?: ApiDashboardResponseV2;
  caseData: Record<string, ApiDashboardResponseV2>;
  isLoading: boolean;
  isInitialized: boolean;
};

export type AnalyticsStore = AnalyticsState & {
  setData: (data: ApiDashboardResponseV2) => void;
  setCaseData: (caseId: string, data: ApiDashboardResponseV2) => void;
  setLoading: (isLoading: boolean) => void;
  setInitialized: (isInitialized: boolean) => void;
  clearCaseData: () => void;
};

export const useAnalyticsStore = create<AnalyticsStore>((set) => ({
  data: undefined,
  caseData: {},
  isLoading: false,
  isInitialized: false,

  setData: (data) => set({ data }),
  setCaseData: (caseId, data) =>
    set((state) => ({ caseData: { ...state.caseData, [caseId]: data } })),
  setLoading: (isLoading) => set({ isLoading }),
  setInitialized: (isInitialized) => set({ isInitialized }),
  clearCaseData: () => set({ caseData: {} }),
}));
